import {
  FETCH_POLICIES_REQUEST, FETCH_POLICIES_SUCCESS, FETCH_POLICIES_FAIL,
  FETCH_EMP_TYPES_REQUEST, FETCH_EMP_TYPES_SUCCESS, FETCH_EMP_TYPES_FAIL,
} from "../../constants/Leave/LeaveConfigConstants";
import LeaveConfigService from "../../service/Leave/LeaveConfigService";
import { fetchLeaveTypes } from "./LeaveTypeAction";
import { extractRows, toDateKey, assertOk } from "../../service/Leave/leaveHelpers";

const errMsg = (error, fallback) => error.response?.data?.Result || error.response?.data?.message || error.message || fallback;
const s = (v) => String(v ?? "").trim();
const n = (v) => Number(v) || 0;
const dk = (v) => (s(v) ? toDateKey(s(v)) : "");

const mapPolicy = (i, idx) => ({
  key: `${s(i.HLP_POLICY_ID) || "row"}-${idx}`,
  id: s(i.HLP_POLICY_ID),
  employeeTypeId: s(i.HLP_EMPLOYEE_TYPE),
  employeeTypeName: s(i.HEC_CATEGORY_NAME),
  leaveTypeId: s(i.HLP_LEAVE_TYPE_ID),
  days: n(i.HLP_ANNUAL_ALLOCATION),
  from: dk(i.HLP_EFFECTIVE_START_DATE ?? i.P_EFFECTIVE_START_DATE ?? i.p_effectiveStartDate),
  to: dk(i.HLP_EFFECTIVE_END_DATE ?? i.P_EFFECTIVE_END_DATE ?? i.p_effectiveEndDate),
  active: ["A", "ACTIVE"].includes((s(i.HLP_ACTIVE_STATUS) || "A").toUpperCase()),
  // columns this page doesn't edit: sent back unchanged when the policy is edited
  keep: {
    monthlyEarn: n(i.HLP_MONTHLY_EARN),
    quarter1: n(i.HLP_QUARTER1),
    quarter2: n(i.HLP_QUARTER2),
    quarter3: n(i.HLP_QUARTER3),
    quarter4: n(i.HLP_QUARTER4),
    prorata: s(i.HLP_PRORATA) || "N",
    carry: s(i.HLP_CARRY_FORWARD).toUpperCase() === "Y" ? "Y" : "N",
    maxCarry: n(i.HLP_MAX_CARRY_FORWARD),
    calcMethod: s(i.HLP_CALCULATION_METHOD) || "ANNUAL_ALLOCATION",
  },
});

const NEW_POLICY_DEFAULTS = {
  monthlyEarn: 0, quarter1: 0, quarter2: 0, quarter3: 0, quarter4: 0,
  prorata: "N", carry: "N", maxCarry: 0, calcMethod: "ANNUAL_ALLOCATION",
};

export const fetchLeavePolicies = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_POLICIES_REQUEST });
    const body = assertOk(await LeaveConfigService.getPolicies());
    dispatch({ type: FETCH_POLICIES_SUCCESS, payload: extractRows(body).map(mapPolicy) });
  } catch (error) {
    dispatch({ type: FETCH_POLICIES_FAIL, payload: errMsg(error, "Failed to fetch leave policies") });
  }
};

export const fetchEmployeeTypes = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_EMP_TYPES_REQUEST });
    const body = assertOk(await LeaveConfigService.getEmployeeTypes());
    const data = extractRows(body)
      .filter((i) => i.HEC_IS_ACTIVE === true || ["TRUE", "1", "Y"].includes(s(i.HEC_IS_ACTIVE).toUpperCase()))
      .map((i) => ({ id: s(i.HEC_EMPLOYMENT_CATEGORY_ID), code: s(i.HEC_CATEGORY_CODE), name: s(i.HEC_CATEGORY_NAME) }))
      .filter((t) => t.id);
    dispatch({ type: FETCH_EMP_TYPES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_EMP_TYPES_FAIL, payload: errMsg(error, "Failed to fetch employee types") });
  }
};

// Each save reloads its list and returns { ok, message }
export const saveLeaveType = (t) => async (dispatch) => {
  try {
    assertOk(await LeaveConfigService.saveLeaveType(t));
    await dispatch(fetchLeaveTypes());
    return { ok: true };
  } catch (error) {
    return { ok: false, message: errMsg(error, "Failed to save leave type") };
  }
};

export const saveLeavePolicy = (p) => async (dispatch) => {
  try {
    assertOk(await LeaveConfigService.savePolicy({ ...p, keep: p.keep || NEW_POLICY_DEFAULTS }));
    await dispatch(fetchLeavePolicies());
    return { ok: true };
  } catch (error) {
    return { ok: false, message: errMsg(error, "Failed to save leave policy") };
  }
};